var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_908_321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.9778 5.9556C4.62239 5.9556 5.9556 4.62239 5.9556 2.9778C5.9556 1.33321 4.62239 0 2.9778 0C1.33321 0 0 1.33321 0 2.9778C0 4.62239 1.33321 5.9556 2.9778 5.9556Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9778 31.9112C4.62239 31.9112 5.9556 30.578 5.9556 28.9334C5.9556 27.2888 4.62239 25.9556 2.9778 25.9556C1.33321 25.9556 0 27.2888 0 28.9334C0 30.578 1.33321 31.9112 2.9778 31.9112Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9778 83.8224C4.62239 83.8224 5.9556 82.4892 5.9556 80.8446C5.9556 79.2 4.62239 77.8668 2.9778 77.8668C1.33321 77.8668 0 79.2 0 80.8446C0 82.4892 1.33321 83.8224 2.9778 83.8224Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9778 135.734C4.62239 135.734 5.9556 134.401 5.9556 132.756C5.9556 131.111 4.62239 129.778 2.9778 129.778C1.33321 129.778 0 131.111 0 132.756C0 134.401 1.33321 135.734 2.9778 135.734Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9778 161.689C4.62239 161.689 5.9556 160.356 5.9556 158.711C5.9556 157.066 4.62239 155.733 2.9778 155.733C1.33321 155.733 0 157.066 0 158.711C0 160.356 1.33321 161.689 2.9778 161.689Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9778 57.8667C4.62239 57.8667 5.9556 56.5335 5.9556 54.8889C5.9556 53.2443 4.62239 51.9111 2.9778 51.9111C1.33321 51.9111 0 53.2443 0 54.8889C0 56.5335 1.33321 57.8667 2.9778 57.8667Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.9778 109.778C4.62239 109.778 5.9556 108.445 5.9556 106.8C5.9556 105.155 4.62239 103.822 2.9778 103.822C1.33321 103.822 0 105.155 0 106.8C0 108.445 1.33321 109.778 2.9778 109.778Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9334 5.9556C30.578 5.9556 31.9112 4.62239 31.9112 2.9778C31.9112 1.33321 30.578 0 28.9334 0C27.2888 0 25.9556 1.33321 25.9556 2.9778C25.9556 4.62239 27.2888 5.9556 28.9334 5.9556Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9334 31.9112C30.578 31.9112 31.9112 30.578 31.9112 28.9334C31.9112 27.2888 30.578 25.9556 28.9334 25.9556C27.2888 25.9556 25.9556 27.2888 25.9556 28.9334C25.9556 30.578 27.2888 31.9112 28.9334 31.9112Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9334 83.8224C30.578 83.8224 31.9112 82.4892 31.9112 80.8446C31.9112 79.2 30.578 77.8668 28.9334 77.8668C27.2888 77.8668 25.9556 79.2 25.9556 80.8446C25.9556 82.4892 27.2888 83.8224 28.9334 83.8224Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9334 135.734C30.578 135.734 31.9112 134.401 31.9112 132.756C31.9112 131.111 30.578 129.778 28.9334 129.778C27.2888 129.778 25.9556 131.111 25.9556 132.756C25.9556 134.401 27.2888 135.734 28.9334 135.734Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9334 161.689C30.578 161.689 31.9112 160.356 31.9112 158.711C31.9112 157.066 30.578 155.733 28.9334 155.733C27.2888 155.733 25.9556 157.066 25.9556 158.711C25.9556 160.356 27.2888 161.689 28.9334 161.689Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9334 57.8667C30.578 57.8667 31.9112 56.5335 31.9112 54.8889C31.9112 53.2443 30.578 51.9111 28.9334 51.9111C27.2888 51.9111 25.9556 53.2443 25.9556 54.8889C25.9556 56.5335 27.2888 57.8667 28.9334 57.8667Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9334 109.778C30.578 109.778 31.9112 108.445 31.9112 106.8C31.9112 105.155 30.578 103.822 28.9334 103.822C27.2888 103.822 25.9556 105.155 25.9556 106.8C25.9556 108.445 27.2888 109.778 28.9334 109.778Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8889 5.9556C56.5335 5.9556 57.8667 4.62239 57.8667 2.9778C57.8667 1.33321 56.5335 0 54.8889 0C53.2443 0 51.9111 1.33321 51.9111 2.9778C51.9111 4.62239 53.2443 5.9556 54.8889 5.9556Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8889 31.9112C56.5335 31.9112 57.8667 30.578 57.8667 28.9334C57.8667 27.2888 56.5335 25.9556 54.8889 25.9556C53.2443 25.9556 51.9111 27.2888 51.9111 28.9334C51.9111 30.578 53.2443 31.9112 54.8889 31.9112Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8889 83.8224C56.5335 83.8224 57.8667 82.4892 57.8667 80.8446C57.8667 79.2 56.5335 77.8668 54.8889 77.8668C53.2443 77.8668 51.9111 79.2 51.9111 80.8446C51.9111 82.4892 53.2443 83.8224 54.8889 83.8224Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8889 135.734C56.5335 135.734 57.8667 134.401 57.8667 132.756C57.8667 131.111 56.5335 129.778 54.8889 129.778C53.2443 129.778 51.9111 131.111 51.9111 132.756C51.9111 134.401 53.2443 135.734 54.8889 135.734Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8889 161.689C56.5335 161.689 57.8667 160.356 57.8667 158.711C57.8667 157.066 56.5335 155.733 54.8889 155.733C53.2443 155.733 51.9111 157.066 51.9111 158.711C51.9111 160.356 53.2443 161.689 54.8889 161.689Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8889 57.8667C56.5335 57.8667 57.8667 56.5335 57.8667 54.8889C57.8667 53.2443 56.5335 51.9111 54.8889 51.9111C53.2443 51.9111 51.9111 53.2443 51.9111 54.8889C51.9111 56.5335 53.2443 57.8667 54.8889 57.8667Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8889 109.778C56.5335 109.778 57.8667 108.445 57.8667 106.8C57.8667 105.155 56.5335 103.822 54.8889 103.822C53.2443 103.822 51.9111 105.155 51.9111 106.8C51.9111 108.445 53.2443 109.778 54.8889 109.778Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8445 5.9556C82.4891 5.9556 83.8223 4.62239 83.8223 2.9778C83.8223 1.33321 82.4891 0 80.8445 0C79.1999 0 77.8667 1.33321 77.8667 2.9778C77.8667 4.62239 79.1999 5.9556 80.8445 5.9556Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8445 31.9112C82.4891 31.9112 83.8223 30.578 83.8223 28.9334C83.8223 27.2888 82.4891 25.9556 80.8445 25.9556C79.1999 25.9556 77.8667 27.2888 77.8667 28.9334C77.8667 30.578 79.1999 31.9112 80.8445 31.9112Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8445 83.8224C82.4891 83.8224 83.8223 82.4892 83.8223 80.8446C83.8223 79.2 82.4891 77.8668 80.8445 77.8668C79.1999 77.8668 77.8667 79.2 77.8667 80.8446C77.8667 82.4892 79.1999 83.8224 80.8445 83.8224Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8445 135.734C82.4891 135.734 83.8223 134.401 83.8223 132.756C83.8223 131.111 82.4891 129.778 80.8445 129.778C79.1999 129.778 77.8667 131.111 77.8667 132.756C77.8667 134.401 79.1999 135.734 80.8445 135.734Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8445 161.689C82.4891 161.689 83.8223 160.356 83.8223 158.711C83.8223 157.066 82.4891 155.733 80.8445 155.733C79.1999 155.733 77.8667 157.066 77.8667 158.711C77.8667 160.356 79.1999 161.689 80.8445 161.689Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8445 57.8667C82.4891 57.8667 83.8223 56.5335 83.8223 54.8889C83.8223 53.2443 82.4891 51.9111 80.8445 51.9111C79.1999 51.9111 77.8667 53.2443 77.8667 54.8889C77.8667 56.5335 79.1999 57.8667 80.8445 57.8667Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8445 109.778C82.4891 109.778 83.8223 108.445 83.8223 106.8C83.8223 105.155 82.4891 103.822 80.8445 103.822C79.1999 103.822 77.8667 105.155 77.8667 106.8C77.8667 108.445 79.1999 109.778 80.8445 109.778Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.8 5.9556C108.445 5.9556 109.778 4.62239 109.778 2.9778C109.778 1.33321 108.445 0 106.8 0C105.155 0 103.822 1.33321 103.822 2.9778C103.822 4.62239 105.155 5.9556 106.8 5.9556Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.8 31.9112C108.445 31.9112 109.778 30.578 109.778 28.9334C109.778 27.2888 108.445 25.9556 106.8 25.9556C105.155 25.9556 103.822 27.2888 103.822 28.9334C103.822 30.578 105.155 31.9112 106.8 31.9112Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.8 83.8224C108.445 83.8224 109.778 82.4892 109.778 80.8446C109.778 79.2 108.445 77.8668 106.8 77.8668C105.155 77.8668 103.822 79.2 103.822 80.8446C103.822 82.4892 105.155 83.8224 106.8 83.8224Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.8 135.734C108.445 135.734 109.778 134.401 109.778 132.756C109.778 131.111 108.445 129.778 106.8 129.778C105.155 129.778 103.822 131.111 103.822 132.756C103.822 134.401 105.155 135.734 106.8 135.734Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.8 161.689C108.445 161.689 109.778 160.356 109.778 158.711C109.778 157.066 108.445 155.733 106.8 155.733C105.155 155.733 103.822 157.066 103.822 158.711C103.822 160.356 105.155 161.689 106.8 161.689Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.8 57.8667C108.445 57.8667 109.778 56.5335 109.778 54.8889C109.778 53.2443 108.445 51.9111 106.8 51.9111C105.155 51.9111 103.822 53.2443 103.822 54.8889C103.822 56.5335 105.155 57.8667 106.8 57.8667Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.8 109.778C108.445 109.778 109.778 108.445 109.778 106.8C109.778 105.155 108.445 103.822 106.8 103.822C105.155 103.822 103.822 105.155 103.822 106.8C103.822 108.445 105.155 109.778 106.8 109.778Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.756 5.9556C134.401 5.9556 135.734 4.62239 135.734 2.9778C135.734 1.33321 134.401 0 132.756 0C131.112 0 129.778 1.33321 129.778 2.9778C129.778 4.62239 131.112 5.9556 132.756 5.9556Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.756 31.9112C134.401 31.9112 135.734 30.578 135.734 28.9334C135.734 27.2888 134.401 25.9556 132.756 25.9556C131.112 25.9556 129.778 27.2888 129.778 28.9334C129.778 30.578 131.112 31.9112 132.756 31.9112Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.756 83.8224C134.401 83.8224 135.734 82.4892 135.734 80.8446C135.734 79.2 134.401 77.8668 132.756 77.8668C131.112 77.8668 129.778 79.2 129.778 80.8446C129.778 82.4892 131.112 83.8224 132.756 83.8224Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.756 135.734C134.401 135.734 135.734 134.401 135.734 132.756C135.734 131.111 134.401 129.778 132.756 129.778C131.112 129.778 129.778 131.111 129.778 132.756C129.778 134.401 131.112 135.734 132.756 135.734Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.756 161.689C134.401 161.689 135.734 160.356 135.734 158.711C135.734 157.066 134.401 155.733 132.756 155.733C131.112 155.733 129.778 157.066 129.778 158.711C129.778 160.356 131.112 161.689 132.756 161.689Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.756 57.8667C134.401 57.8667 135.734 56.5335 135.734 54.8889C135.734 53.2443 134.401 51.9111 132.756 51.9111C131.112 51.9111 129.778 53.2443 129.778 54.8889C129.778 56.5335 131.112 57.8667 132.756 57.8667Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.756 109.778C134.401 109.778 135.734 108.445 135.734 106.8C135.734 105.155 134.401 103.822 132.756 103.822C131.112 103.822 129.778 105.155 129.778 106.8C129.778 108.445 131.112 109.778 132.756 109.778Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.711 5.9556C160.356 5.9556 161.689 4.62239 161.689 2.9778C161.689 1.33321 160.356 0 158.711 0C157.067 0 155.733 1.33321 155.733 2.9778C155.733 4.62239 157.067 5.9556 158.711 5.9556Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.711 31.9112C160.356 31.9112 161.689 30.578 161.689 28.9334C161.689 27.2888 160.356 25.9556 158.711 25.9556C157.067 25.9556 155.733 27.2888 155.733 28.9334C155.733 30.578 157.067 31.9112 158.711 31.9112Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.711 83.8224C160.356 83.8224 161.689 82.4892 161.689 80.8446C161.689 79.2 160.356 77.8668 158.711 77.8668C157.067 77.8668 155.733 79.2 155.733 80.8446C155.733 82.4892 157.067 83.8224 158.711 83.8224Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.711 135.734C160.356 135.734 161.689 134.401 161.689 132.756C161.689 131.111 160.356 129.778 158.711 129.778C157.067 129.778 155.733 131.111 155.733 132.756C155.733 134.401 157.067 135.734 158.711 135.734Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.711 161.689C160.356 161.689 161.689 160.356 161.689 158.711C161.689 157.066 160.356 155.733 158.711 155.733C157.067 155.733 155.733 157.066 155.733 158.711C155.733 160.356 157.067 161.689 158.711 161.689Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.711 57.8667C160.356 57.8667 161.689 56.5335 161.689 54.8889C161.689 53.2443 160.356 51.9111 158.711 51.9111C157.067 51.9111 155.733 53.2443 155.733 54.8889C155.733 56.5335 157.067 57.8667 158.711 57.8667Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.711 109.778C160.356 109.778 161.689 108.445 161.689 106.8C161.689 105.155 160.356 103.822 158.711 103.822C157.067 103.822 155.733 105.155 155.733 106.8C155.733 108.445 157.067 109.778 158.711 109.778Z",
    fill: "white",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_908_321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162,
    height: 162,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.fa2b3d7532f5765a7e28ea0ab27e1975.svg";
export { ForwardRef as ReactComponent };